import { render, staticRenderFns } from "./GuidesForm.vue?vue&type=template&id=64a4121e&scoped=true"
import script from "./GuidesForm.vue?vue&type=script&lang=js"
export * from "./GuidesForm.vue?vue&type=script&lang=js"
import style0 from "./GuidesForm.vue?vue&type=style&index=0&id=64a4121e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a4121e",
  null
  
)

export default component.exports